/* ===================================================================
   Upsell Popup - Post-add-to-cart upsell

   Trin 0 (24/08/2026): farve-godkendelse ved lang leveringstid.
   Vises FOER trin 1 og 2, og FOER varen laegges i kurven, saa kundens
   valg kan foelge med som line item property paa selve ordrelinjen.

   Betingelse for trin 0:
     - produktet har en option hvis navn indeholder "farve" med >1 vaerdi
     - den variant kunden har valgt lige nu har custom.delivery_date == "5-9"
     - der findes mindst en anden farve end den valgte

   Resultat paa ordren:
     properties["Accepterer også farve"] = "Sort, Blå"
   =================================================================== */

(function () {
  'use strict';

  /* -------------------------------------------------------
     Diagnose. Slaas til med ?upsellDebug=1 i adressen.
     Uden flaget goer den ingenting og koster ingenting.
  ------------------------------------------------------- */
  var DEBUG = false;
  try { DEBUG = new URLSearchParams(location.search).get('upsellDebug') === '1'; } catch (e) {}

  var VERSION = 'v11 24/08';

  function debugBox() {
    var box = document.getElementById('upsell-debug-box');
    if (!box) {
      box = document.createElement('div');
      box.id = 'upsell-debug-box';
      box.style.cssText = 'position:fixed;left:0;right:0;top:0;z-index:2147483647;' +
        'background:#102420;color:#c8e0d6;font:12px/1.5 ui-monospace,Menlo,monospace;' +
        'padding:10px 12px;max-height:60vh;overflow:auto;white-space:pre-wrap;' +
        'border-bottom:3px solid #54c63a;pointer-events:none;opacity:.96';
      box.textContent = 'UPSELL DIAGNOSE ' + VERSION + '\n';
    }
    // Popup'en flyttes til slutningen af body naar den aabnes. Vi flytter
    // boksen med, ellers ligger den bagved og kan ikke ses.
    if (document.body && box.parentElement !== document.body) document.body.appendChild(box);
    else if (document.body) document.body.appendChild(box);
    return box;
  }

  function dbg(line) {
    if (!DEBUG || !document.body) return;
    debugBox().textContent += line + '\n';
  }

  function dbgLift() {
    if (!DEBUG) return;
    setTimeout(function () { debugBox(); }, 0);
  }

  /* -------------------------------------------------------
     Trin 0 data
  ------------------------------------------------------- */
  var COLOUR_DATA = null;
  var SLOW_VALUE = '5-9';
  var FAST_VALUE = '1-3';

  // Liquid kan levere option-vaerdier som strenge eller som objekter.
  // Vi normaliserer til rene strenge, saa resten af koden kun ser tekst.
  function norm(v) {
    if (v === null || v === undefined) return '';
    if (typeof v === 'object') return String(v.name || v.title || v.value || '');
    return String(v);
  }

  var SKIP_REASON = '';
  var DATA_SOURCE = '';

  /* -------------------------------------------------------
     Variantdata. Tre kilder, i prioriteret raekkefoelge:
       1. min egen datablok fra Liquid
       2. temaets egen variant-vaelger, som allerede udstiller
          {{ product.variants | json }} inde i <variant-radios>
       3. ingen, saa springer vi trin 0 over
     Kilde 2 er den samme som variantvalget paa siden bruger,
     saa den kan ikke vaere uenig med det kunden ser.
  ------------------------------------------------------- */
  function mapFromPickerHost(host) {
    if (!host) return null;
    var tag = host.querySelector('script[type="application/json"]');
    if (!tag) return null;
    var arr;
    try { arr = JSON.parse(tag.textContent || 'null'); } catch (e) { return null; }
    if (!Array.isArray(arr) || !arr.length) return null;

    var out = {};
    arr.forEach(function (v) {
      if (!v || !v.id) return;
      var img = '';
      if (v.featured_image && v.featured_image.src) img = v.featured_image.src;
      else if (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) {
        img = v.featured_media.preview_image.src;
      }
      out[String(v.id)] = {
        d: '',
        a: v.available !== false,
        p: v.price,
        i: img,
        o: (v.options || []).map(norm)
      };
    });
    return Object.keys(out).length ? out : null;
  }

  // Der kan ligge flere variant-vaelgere paa siden, fx fra relaterede
  // produkter eller upsell-sektioner. Vi vaelger den kilde der faktisk
  // indeholder den variant kunden staar paa, ikke bare den foerste.
  function candidateSources() {
    var list = [];

    var el = document.getElementById('upsell-colour-data');
    if (el) {
      try {
        var own = JSON.parse(el.textContent || 'null');
        if (own && own.variants && Object.keys(own.variants).length) {
          list.push({ src: 'egen datablok', variants: own.variants, meta: own, host: null });
        }
      } catch (e) {
        SKIP_REASON = 'egen datablok er ikke gyldig JSON: ' + e.message;
      }
    }

    var hosts = document.querySelectorAll('variant-radios, variant-selects');
    Array.prototype.forEach.call(hosts, function (host, i) {
      var m = mapFromPickerHost(host);
      if (m) list.push({ src: 'variant-vaelger ' + (i + 1) + '/' + hosts.length, variants: m, meta: {}, host: host });
    });

    return list;
  }

  function optionNamesFromHost(host) {
    if (!host) return [];
    var legends = host.querySelectorAll('legend, label.product-form__group-name');
    if (legends.length) {
      return Array.prototype.map.call(legends, function (el) {
        return (el.textContent || '').replace(/:\s*$/, '').trim();
      }).filter(Boolean);
    }
    var selects = host.querySelectorAll('select[name^="options["]');
    return Array.prototype.map.call(selects, function (el) {
      var m = (el.name || '').match(/^options\[(.+)\]$/);
      return m ? m[1] : '';
    }).filter(Boolean);
  }

  function readColourData(wantedId) {
    var sources = candidateSources();
    if (!sources.length) {
      SKIP_REASON = SKIP_REASON || 'ingen datakilde: hverken egen datablok eller en variant-vaelger';
      return null;
    }

    var chosen = null;
    if (wantedId) {
      for (var i = 0; i < sources.length; i++) {
        if (sources[i].variants[wantedId]) { chosen = sources[i]; break; }
      }
    }
    if (!chosen) {
      chosen = sources[0];
      if (wantedId) {
        SKIP_REASON = 'variant ' + wantedId + ' fandtes ikke i nogen kilde. Kilder: ' +
          sources.map(function (s) { return s.src + ' med ' + Object.keys(s.variants).length; }).join(', ');
      }
    }

    var d = chosen.meta || {};
    d.variants = chosen.variants;
    DATA_SOURCE = chosen.src + ', ' + Object.keys(chosen.variants).length + ' varianter, ' +
      sources.length + ' kilde(r) paa siden';

    if (!d.propertyName) d.propertyName = 'Accepterer også farve';

    Object.keys(d.variants).forEach(function (vid) {
      var v = d.variants[vid];
      if (v && Array.isArray(v.o)) v.o = v.o.map(norm);
    });

    var themeMap = {};
    try {
      var mapEl = document.getElementById('dynamic-delivery-display');
      themeMap = JSON.parse((mapEl && mapEl.dataset.deliveryMap) || '{}');
    } catch (e) { themeMap = {}; }
    d.themeMapSize = Object.keys(themeMap).length;

    Object.keys(d.variants).forEach(function (vid) {
      var fromTheme = norm(themeMap[vid]).trim();
      var fromLiquid = norm(d.variants[vid].d).trim();
      d.variants[vid].d = fromTheme || fromLiquid;
    });

    var names = optionNamesFromHost(chosen.host);
    if (!names.length) names = optionNamesFromHost(document.querySelector('variant-radios, variant-selects'));
    if (!names.length && Array.isArray(d.optionNames)) names = d.optionNames.map(norm);
    d.optionNames = names;

    d.colourIndex = -1;
    for (var j = 0; j < names.length; j++) {
      var lower = String(names[j]).toLowerCase();
      if (lower.indexOf('farve') !== -1 || lower.indexOf('colour') !== -1 || lower.indexOf('color') !== -1) {
        d.colourIndex = j;
        break;
      }
    }
    if (d.colourIndex === -1) {
      SKIP_REASON = 'ingen option med farve i navnet. Fundne options: ' + (names.join(' / ') || 'ingen');
      return null;
    }

    var seen = [];
    Object.keys(d.variants).forEach(function (vid) {
      var v = d.variants[vid];
      var c = v && Array.isArray(v.o) ? v.o[d.colourIndex] : '';
      if (c && seen.indexOf(c) === -1) seen.push(c);
    });
    d.colours = seen;

    if (d.colours.length < 2) {
      SKIP_REASON = 'produktet har kun én farve: ' + (d.colours.join(', ') || 'ingen');
      return null;
    }

    return d;
  }

  // Laeser data paa ny hvis vi ikke kender den variant kunden staar paa nu.
  function ensureData(productForm) {
    var vid = currentVariantId(productForm);
    if (COLOUR_DATA && vid && COLOUR_DATA.variants[vid]) return COLOUR_DATA;
    SKIP_REASON = '';
    COLOUR_DATA = readColourData(vid);
    return COLOUR_DATA;
  }


  function currentVariantId(productForm) {
    var val = '';

    try {
      var field = productForm.elements ? productForm.elements['id'] : null;
      if (field) {
        if (field.value !== undefined) {
          val = field.value;
        } else if (field.length) {
          for (var i = 0; i < field.length; i++) {
            if (field[i].checked || field[i].selected) { val = field[i].value; break; }
          }
          if (!val && field[0]) val = field[0].value;
        }
      }
    } catch (e) {}

    if (!/^\d+$/.test(String(val))) {
      var el = productForm.querySelector('[name="id"]:checked') || productForm.querySelector('[name="id"]');
      if (el && el.value) val = el.value;
    }

    if (!/^\d+$/.test(String(val))) {
      try {
        var fromUrl = new URLSearchParams(window.location.search).get('variant');
        if (fromUrl && /^\d+$/.test(fromUrl)) val = fromUrl;
      } catch (e) {}
    }

    if (!/^\d+$/.test(String(val)) && window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId) {
      val = String(window.ShopifyAnalytics.meta.selectedVariantId);
    }

    return String(val || '');
  }

  function currentVariantInfo(productForm) {
    if (!COLOUR_DATA) return null;
    return COLOUR_DATA.variants[currentVariantId(productForm)] || null;
  }

  function currentColour(productForm) {
    var info = currentVariantInfo(productForm);
    if (!info || !Array.isArray(info.o)) return '';
    return info.o[COLOUR_DATA.colourIndex] || '';
  }

  // Trin 0 vises kun naar den valgte variant faktisk har 5-9
  function needsColourStep(productForm) {
    if (!ensureData(productForm)) return false;
    var info = currentVariantInfo(productForm);
    if (!info) return false;
    if (String(info.d || '').trim() !== SLOW_VALUE) return false;
    return otherColours(productForm).length > 0;
  }

  function otherColours(productForm) {
    var cur = currentColour(productForm);
    return COLOUR_DATA.colours.filter(function (c) { return c !== cur; });
  }

  /* -------------------------------------------------------
     Farve-swatches
     Bruges kun naar en variant ikke har sit eget billede.
  ------------------------------------------------------- */
  var SWATCH = {
    'sort': '#1c1c1e', 'space black': '#1a1a1c', 'astral black': '#1a1a1c',
    'jet black': '#141416', 'obsidian': '#1e2022', 'sort titanium': '#3a3a3c',
    'hvid': '#f3f3f5', 'hvidt titanium': '#e6e4df', 'porcelain': '#ece5da',
    'beige': '#e7dcc9', 'stjerneskær': '#efe6da', 'sandfarvet titanium': '#c9bda6',
    'sølv': '#d8d9dd', 'titanium': '#b9b4ab', 'naturligt titanium': '#b9b4ab',
    'naturlig titanium': '#b9b4ab', 'moonstone': '#9aa3ab', 'moonstone gray': '#9aa3ab',
    'grå': '#8e8e93', 'koksgrå': '#4a4a4f', 'grafitgrå': '#5b5b5f',
    'space grey': '#6f6f74', 'space gray': '#6f6f74',
    'guld': '#e3c58f', 'rosa guld': '#ecc7bd',
    'blå': '#2f6fdb', 'dybblå': '#1b3a6b', 'navy': '#1b3a6b',
    'lyseblå': '#a9d3f0', 'himmelblå': '#a9d3f0', 'skyfri blå': '#bcd9ee',
    'iceblue': '#cfe6f2', 'stillehavsblå': '#4e6e7d', 'blåt titanium': '#4f5f74',
    'ultramarin': '#2b3fbf', 'ultramarine': '#2b3fbf', 'grønblå': '#2e7d7d',
    'grøn': '#34a853', 'grangrøn': '#2e5d43', 'midnatsgrøn': '#204034',
    'emerald dusk': '#2f6b57', 'mint': '#b9e3cf',
    'rød': '#d62b2b', 'koral': '#f2755c',
    'orange': '#f28c28', 'kosmisk orange': '#e2582a',
    'gul': '#f2c94c', 'lemon': '#f7e26b',
    'lilla': '#7b4bd1', 'dyblilla': '#4b2a86', 'violet': '#7a3fb5',
    'lavendel': '#c9b6ec', 'lilac': '#c3a8e0', 'lyserød': '#f4a8c0',
    'midnat': '#1f2430'
  };

  function swatchStyle(name) {
    var parts = String(name).toLowerCase().split(/\s*[+&]\s*/).map(function (s) {
      return SWATCH[s.trim()] || null;
    });
    var hits = parts.filter(Boolean);
    if (hits.length === 0) return 'background:#e4ebe7';
    if (hits.length === 1) return 'background:' + hits[0];
    return 'background:linear-gradient(135deg,' + hits[0] + ' 0 50%,' + hits[1] + ' 50% 100%)';
  }

  /* -------------------------------------------------------
     Del farverne op i to grupper
       fast  = farver vi har paa lager nu (1-3) i praecis samme
               stand og hukommelse som kundens valg. Vaelger kunden
               en af dem, skifter vi ordren til den variant.
       other = alle oevrige farver. Vises uden leveringstid og
               noteres kun som accepteret paa ordren.
  ------------------------------------------------------- */
  function buildRows(productForm) {
    var info = currentVariantInfo(productForm);
    var idx = COLOUR_DATA.colourIndex;
    var cur = currentColour(productForm);
    var sibling = {};
    var anyOf = {};

    Object.keys(COLOUR_DATA.variants).forEach(function (vid) {
      var v = COLOUR_DATA.variants[vid];
      if (!v || !Array.isArray(v.o)) return;
      var colour = v.o[idx];
      if (!colour) return;

      if (!anyOf[colour]) anyOf[colour] = v;

      var isSibling = !!(info && Array.isArray(info.o) && v.o.length === info.o.length &&
        v.o.every(function (val, i) { return i === idx || val === info.o[i]; }));

      if (isSibling && !sibling[colour]) {
        sibling[colour] = { vid: vid, d: String(v.d || '').trim(), a: v.a !== false, i: v.i || '', p: v.p };
      }
    });

    var fast = [], other = [];

    COLOUR_DATA.colours.forEach(function (colour) {
      if (colour === cur) return;
      var s = sibling[colour];
      var img = (s && s.i) || (anyOf[colour] && anyOf[colour].i) || '';

      if (s && s.d === FAST_VALUE && s.a) {
        fast.push({ c: colour, img: img, vid: s.vid, p: s.p });
      } else {
        other.push({ c: colour, img: img });
      }
    });

    return { fast: fast, other: other, currentPrice: info ? info.p : null };
  }

  function setColourProperty(productForm, colours) {
    var name = 'properties[' + (COLOUR_DATA.propertyName || 'Accepterer også farve') + ']';
    var input = formField(productForm, name);
    if (!colours.length) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      productForm.appendChild(input);
    }
    input.value = colours.join(', ');
  }

  /* -------------------------------------------------------
     Init
  ------------------------------------------------------- */
  function init() {
    const root = document.getElementById('upsell-popup-root');

    const productFormEl = document.querySelector('product-form');
    const productForm = (productFormEl && productFormEl.querySelector('form[action*="/cart/add"]'))
                        || document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    const submitBtn = productForm.querySelector('[type="submit"], .product-form__submit');
    if (!submitBtn) return;

    COLOUR_DATA = ensureData(productForm);

    if (DEBUG) {
      var raw = document.getElementById('upsell-colour-data');
      dbg('--- init ---');
      dbg('vaert: ' + location.hostname);
      dbg('popup-rod fundet: ' + !!root);
      dbg('liquid: ' + (root ? (root.dataset.step0Debug || 'ingen debug-attribut') : 'n/a'));
      dbg('has-step0 attribut: ' + (root ? root.dataset.hasStep0 : 'n/a'));
      dbg('datablok i DOM: ' + !!raw);
      dbg('datakilde: ' + (DATA_SOURCE || 'ingen'));
      dbg('datablok parsed: ' + !!COLOUR_DATA);
      if (!COLOUR_DATA) dbg('AARSAG: ' + SKIP_REASON);
      if (raw && !COLOUR_DATA) dbg('foerste 300 tegn: ' + (raw.textContent || '').slice(0, 300));
      if (COLOUR_DATA) {
        dbg('farver udledt: ' + COLOUR_DATA.colours.join(', '));
        dbg('option-navne: ' + (COLOUR_DATA.optionNames || []).join(' / '));
        dbg('farveindeks: ' + COLOUR_DATA.colourIndex);
        dbg('varianter i map: ' + Object.keys(COLOUR_DATA.variants).length);
        dbg('temaets leveringskort: ' + COLOUR_DATA.themeMapSize + ' varianter');
        var dCount = {};
        Object.keys(COLOUR_DATA.variants).forEach(function (k) {
          var val = COLOUR_DATA.variants[k].d || '(tom)';
          dCount[val] = (dCount[val] || 0) + 1;
        });
        dbg('leveringstider: ' + Object.keys(dCount).map(function (k) { return k + ' x' + dCount[k]; }).join(', '));
      }
    }

    // --- Ingen popup → cart drawer fallback ---
    if (!root) {
      [submitBtn, document.getElementById('floating-buy-button')].filter(Boolean).forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
          if (!productForm.checkValidity()) { productForm.reportValidity(); return; }
          await addMainToCart(productForm, btn, true);
        }, true);
      });
      return;
    }

    // --- Parse data ---
    let step1 = [], step2 = [];
    try { step1 = JSON.parse(root.dataset.step1 || '[]'); } catch(e) {}
    try { step2 = JSON.parse(root.dataset.step2 || '[]'); } catch(e) {}
    const hasStep1 = step1.length > 0;
    const hasStep2 = step2.length > 0;
    const usePopup = hasStep1 || hasStep2;

    let pendingBtn = null;

    async function proceed(btn) {
      const ok = await addMainToCart(productForm, btn, !usePopup);
      if (!ok) return;
      if (hasStep1) showStep(root, 1);
      else if (hasStep2) showStep(root, 2);
      // hverken trin 1 eller 2: addMainToCart har allerede aabnet cart drawer
    }

    buildPopup(root, step1, step2, hasStep1, hasStep2);

    // --- Trin 0 knapper ---
    document.getElementById('step0-next')?.addEventListener('click', async () => {
      const fast = pickedFast();
      const others = pickedOther();
      const before = currentColour(productForm);

      if (fast) {
        // Kunden tager en farve vi har paa lager: skift varen i kurven
        switchVariant(productForm, fast.dataset.vid);
        setProperty(productForm, 'Farve skiftet fra', before);
      } else {
        setProperty(productForm, 'Farve skiftet fra', '');
      }

      setColourProperty(productForm, others);
      closePopup(root);
      const btn = pendingBtn; pendingBtn = null;
      await proceed(btn);
    });

    // --- Intercept add to cart ---
    [submitBtn, document.getElementById('floating-buy-button')].filter(Boolean).forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
        if (!productForm.checkValidity()) { productForm.reportValidity(); return; }

        if (DEBUG) {
          var vid = currentVariantId(productForm);
          var vinfo = COLOUR_DATA ? COLOUR_DATA.variants[vid] : null;
          dbg('--- klik ---');
          ensureData(productForm);
          dbg('datakilde: ' + (DATA_SOURCE || 'ingen'));
          dbg('data ok: ' + !!COLOUR_DATA);
          if (!COLOUR_DATA) dbg('AARSAG: ' + (SKIP_REASON || 'ukendt'));
          if (COLOUR_DATA) {
            dbg('farver: ' + COLOUR_DATA.colours.join(', '));
            dbg('options: ' + (COLOUR_DATA.optionNames || []).join(' / ') + '  farveindeks: ' + COLOUR_DATA.colourIndex);
            dbg('temaets leveringskort: ' + COLOUR_DATA.themeMapSize + ' varianter');
          }
          dbg('valgt variant: ' + vid);
          dbg('variant i map: ' + !!vinfo);
          dbg('delivery_date: ' + (vinfo ? JSON.stringify(vinfo.d) : 'n/a'));
          dbg('options: ' + (vinfo ? (vinfo.o || []).join(' / ') : 'n/a'));
          if (COLOUR_DATA && vinfo) {
            var r = buildRows(productForm);
            dbg('kan sendes nu: ' + (r.fast.map(function (x) { return x.c; }).join(', ') || 'ingen'));
            dbg('andre farver: ' + (r.other.map(function (x) { return x.c; }).join(', ') || 'ingen'));
          }
          dbg('viser trin 0: ' + needsColourStep(productForm));
        }

        if (needsColourStep(productForm)) {
          pendingBtn = btn;
          buildColourStep(root, productForm);
          showStep(root, 0);
          return;
        }

        // Ingen lang leveringstid: fjern en evt. tidligere sat property
        if (COLOUR_DATA) setColourProperty(productForm, []);
        await proceed(btn);
      }, true);
    });
  }

  /* -------------------------------------------------------
     Byg trin 0 (farve-godkendelse)
  ------------------------------------------------------- */
  function buildColourStep(root, productForm) {
    setText('#upsell-step0-badge',   root.dataset.step0Badge);
    setText('#upsell-step0-heading', root.dataset.step0Heading);
    setText('#upsell-step0-sub',     root.dataset.step0Sub);

    const cur = currentColour(productForm);
    const info = currentVariantInfo(productForm);
    const rows = buildRows(productForm);

    // Kundens nuvaerende valg
    const current = document.getElementById('upsell-current-choice');
    if (current) {
      current.innerHTML = `
        ${swatchHtml(cur, info && info.i)}
        <div class="upsell-current-meta">
          <span class="upsell-eyebrow">Dit valg</span>
          <div class="upsell-current-name">${escapeHtml(cur || 'Valgt variant')}</div>
          <span class="upsell-eta slow">5-9 hverdage</span>
        </div>
      `;
    }

    // Gruppe 1: kan sendes nu. Kun en ad gangen, for vi skifter varen i kurven.
    const fastSection = document.getElementById('upsell-fast-section');
    const fastWrap = document.getElementById('upsell-colour-fast');
    if (fastWrap) {
      fastWrap.innerHTML = '';
      rows.fast.forEach((row, i) => {
        const card = buildColourCard('fast-' + i, row.c, row.img, true, '1-3 hverdage');
        const cb = card.querySelector('input');
        cb.dataset.vid = row.vid;
        cb.dataset.price = (row.p === undefined || row.p === null) ? '' : String(row.p);
        cb.addEventListener('change', () => {
          if (cb.checked) {
            // kun en farve kan vaelges her
            fastWrap.querySelectorAll('input').forEach(other => {
              if (other !== cb && other.checked) {
                other.checked = false;
                other.closest('.upsell-colour-card').classList.remove('selected');
              }
            });
          }
          card.classList.toggle('selected', cb.checked);
          updateStep0Button(root, productForm);
        });
        fastWrap.appendChild(card);
      });
    }
    if (fastSection) fastSection.style.display = rows.fast.length ? '' : 'none';

    // Gruppe 2: alle andre farver, uden leveringstid
    const otherSection = document.getElementById('upsell-other-section');
    const otherWrap = document.getElementById('upsell-colour-other');
    if (otherWrap) {
      otherWrap.innerHTML = '';
      rows.other.forEach((row, i) => {
        const card = buildColourCard('other-' + i, row.c, row.img, false, '');
        const cb = card.querySelector('input');
        cb.addEventListener('change', () => {
          card.classList.toggle('selected', cb.checked);
          updateStep0Button(root, productForm);
        });
        otherWrap.appendChild(card);
      });
    }
    if (otherSection) otherSection.style.display = rows.other.length ? '' : 'none';

    updateStep0Button(root, productForm);
  }

  function buildColourCard(id, colour, img, isFast, etaText) {
    const domId = 'upsell-colour-' + id;
    const card = document.createElement('label');
    card.className = 'upsell-colour-card' + (isFast ? ' fast' : '');
    card.setAttribute('for', domId);
    card.innerHTML = `
      <input type="checkbox" id="${domId}" value="${escapeHtml(colour)}">
      ${swatchHtml(colour, img)}
      <div class="upsell-colour-info">
        <div class="upsell-colour-name">${escapeHtml(colour)}</div>
        ${etaText ? `<span class="upsell-eta fast">${escapeHtml(etaText)}</span>` : ''}
      </div>
      <span class="upsell-tick">✓</span>
    `;
    return card;
  }

  function pickedFast() {
    return document.querySelector('#upsell-colour-fast input:checked');
  }

  function pickedOther() {
    return Array.from(document.querySelectorAll('#upsell-colour-other input:checked'))
      .map(cb => cb.value);
  }

  function updateStep0Button(root, productForm) {
    const btn = document.getElementById('step0-next');
    if (!btn) return;
    const fast = pickedFast();
    const others = pickedOther();

    if (fast) {
      btn.textContent = 'Skift til ' + fast.value + ' og fortsæt';
    } else if (others.length === 1) {
      btn.textContent = 'Godkend 1 farve og fortsæt';
    } else if (others.length > 1) {
      btn.textContent = 'Godkend ' + others.length + ' farver og fortsæt';
    } else {
      btn.textContent = root.dataset.step0Next || 'Gå videre →';
    }
  }

  /* -------------------------------------------------------
     Skift varen i kurven til den hurtige farve
  ------------------------------------------------------- */
  // Samme faelde som ved variant-opslaget: feltet kan ligge uden for
  // formularen og vaere haegtet paa med form="...". elements ser det, det
  // goer querySelector ikke.
  function formField(productForm, name) {
    try {
      var f = productForm.elements ? productForm.elements[name] : null;
      if (f) {
        if (f.value !== undefined) return f;
        if (f.length) return f[0];
      }
    } catch (e) {}
    return productForm.querySelector('[name="' + name.replace(/"/g, '\\"') + '"]');
  }

  function switchVariant(productForm, variantId) {
    var changed = false;

    try {
      var all = productForm.elements ? productForm.elements['id'] : null;
      if (all && all.value !== undefined) {
        all.value = String(variantId);
        changed = true;
      } else if (all && all.length) {
        for (var i = 0; i < all.length; i++) {
          all[i].value = String(variantId);
          changed = true;
        }
      }
    } catch (e) {}

    if (!changed) {
      var el = productForm.querySelector('select[name="id"]') || productForm.querySelector('input[name="id"]');
      if (el) { el.value = String(variantId); changed = true; }
    }

    // Sidste udvej: laeg et felt ind i formularen med det rigtige id.
    // Et felt inde i formularen vinder over et der kun er haegtet paa.
    if (!changed) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'id';
      hidden.value = String(variantId);
      productForm.appendChild(hidden);
    }

    // Leveringstiden paa ordren skal foelge med, ellers staar der 5-9
    // paa en ordre vi sender inden for 1-3.
    var dd = formField(productForm, 'properties[Delivery Date]');
    if (dd) dd.value = 'Levering: 1-3 hverdage';

    return String(variantId);
  }

  function setProperty(productForm, name, value) {
    let input = formField(productForm, 'properties[' + name + ']');
    if (!value) { if (input) input.remove(); return; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      productForm.appendChild(input);
    }
    input.value = value;
  }

  function swatchHtml(colour, img) {
    const fill = `<span class="upsell-swatch-fill" style="${swatchStyle(colour)}"></span>`;
    if (!img) return `<span class="upsell-swatch">${fill}</span>`;
    return `<span class="upsell-swatch">${fill}<img src="${escapeHtml(img)}" alt="${escapeHtml(colour)}" loading="lazy" onerror="this.remove()"></span>`;
  }

  /* -------------------------------------------------------
     Byg popup UI
  ------------------------------------------------------- */
  function buildPopup(root, step1, step2, hasStep1, hasStep2) {

    // Tekster
    setText('#upsell-step1-badge',   root.dataset.step1Badge);
    setText('#upsell-step1-heading', root.dataset.step1Heading);
    setText('#upsell-step1-sub',     root.dataset.step1Sub);
    setText('#upsell-step2-heading', root.dataset.step2Heading);
    setText('#upsell-step2-sub',     root.dataset.step2Sub);

    const nextBtn = document.getElementById('step1-next');
    if (nextBtn) nextBtn.textContent = root.dataset.step1Next || 'Gå videre →';
    const skipBtn = document.getElementById('step2-skip');
    if (skipBtn) skipBtn.textContent = root.dataset.step2Skip || 'Gå videre uden tilkøb →';

    // Step 1 produkter
    const s1Container = document.getElementById('upsell-step1-products');
    if (s1Container && step1.length > 0) {
      if (step1.length === 1) s1Container.classList.add('one-product');
      step1.forEach(p => s1Container.appendChild(buildCard(p, 'Tilkøb')));
    }

    // Step 2 produkter
    const s2Container = document.getElementById('upsell-step2-products');
    if (s2Container && step2.length > 0) {
      step2.forEach(p => s2Container.appendChild(buildCard(p, 'Tilføj til kurv')));
    }

    // Luk ved klik på overlay (udenfor popup-boksen)
    root.querySelectorAll('[data-popup-close]').forEach(el => {
      el.addEventListener('click', () => closePopup(root));
    });

    // Escape tast
    document.addEventListener('keydown', (e) => {
      if (e.code === 'Escape' && root.style.display !== 'none') closePopup(root);
    });

    // Step 1 → Step 2
    document.getElementById('step1-next')?.addEventListener('click', () => {
      hasStep2 ? showStep(root, 2) : (window.location.href = '/checkout');
    });

    // Step 2 actions
    document.getElementById('step2-checkout')?.addEventListener('click', () => {
      window.location.href = '/checkout';
    });
    document.getElementById('step2-continue')?.addEventListener('click', () => {
      closePopup(root);
    });
    document.getElementById('step2-skip')?.addEventListener('click', () => {
      window.location.href = '/checkout';
    });
  }

  /* -------------------------------------------------------
     Byg produktkort med nye CSS-klasser
  ------------------------------------------------------- */
  function buildCard(product, btnLabel) {
    const card = document.createElement('div');
    card.className = 'upsell-product';

    const priceStr = formatDKK(product.price);
    const compareStr = product.comparePrice > product.price
      ? `<span class="upsell-old-price">${formatDKK(product.comparePrice)}</span>`
      : '';

    card.innerHTML = `
      <div class="upsell-product-image">
        ${product.image
          ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">`
          : ''}
      </div>
      <div class="upsell-product-info">
        <div class="upsell-product-title">${escapeHtml(product.title)}</div>
        ${product.excerpt ? `<div class="upsell-product-description">${escapeHtml(product.excerpt)}</div>` : ''}
        <div>
          <span class="upsell-price">${priceStr}</span>${compareStr}
        </div>
        <button type="button" class="upsell-add" data-variant="${product.variantId}">
          ${escapeHtml(btnLabel)}
        </button>
      </div>
    `;

    const btn = card.querySelector('.upsell-add');
    btn.addEventListener('click', async () => {
      if (btn.disabled) return;
      btn.disabled = true;
      const original = btn.textContent.trim();
      btn.textContent = '...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(product.variantId), quantity: 1 }] })
        });
        if (res.ok) {
          btn.textContent = 'Tilføjet ✓';
          btn.classList.add('added');
          updateCartCount();
        } else {
          btn.disabled = false;
          btn.textContent = original;
        }
      } catch {
        btn.disabled = false;
        btn.textContent = original;
      }
    });

    return card;
  }

  /* -------------------------------------------------------
     Add main product to cart
  ------------------------------------------------------- */
  async function addMainToCart(productForm, btn, openDrawer) {
    const formData = new FormData(productForm);
    const mainId = formData.get('id');
    if (!mainId) { alert('Vælg venligst en variant'); return false; }

    const qty = parseInt(formData.get('quantity') || '1', 10);
    const properties = {};
    formData.forEach((val, key) => {
      const m = key.match(/^properties\[(.+)\]$/);
      if (m && val) properties[m[1]] = val;
    });

    const items = [{ id: parseInt(mainId), quantity: qty }];
    if (Object.keys(properties).length > 0) items[0].properties = properties;

    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }

    const body = { items };
    if (openDrawer) {
      const sections = [];
      if (document.querySelector('cart-drawer')) sections.push('cart-drawer');
      if (document.querySelector('cart-icon-bubble, #cart-icon-bubble')) sections.push('cart-icon-bubble');
      if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok) { showFormError(data.description || 'Kunne ikke tilføje til kurv', productForm); return false; }

      if (openDrawer) {
        // Fallback: åbn cart drawer og dispatch events
        if (data.sections) {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
          } else {
            window.location.href = '/cart';
          }
        }
        // Dispatch kun når vi IKKE viser upsell popup
        try {
          if (window.PUB_SUB_EVENTS?.cartUpdate && window.publish) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
          }
        } catch {}
      }
      // Når upsell popup vises: INGEN cart events – undgår konflikter med andre apps

      return true;
    } catch {
      showFormError('Der opstod en fejl. Prøv igen.', productForm);
      return false;
    } finally {
      if (btn) { btn.setAttribute('aria-disabled', 'false'); btn.classList.remove('loading'); }
    }
  }

  /* -------------------------------------------------------
     Vis/skjul steps
  ------------------------------------------------------- */
  function showStep(root, step) {
    if (root.parentElement !== document.body) document.body.appendChild(root);

    const s0 = document.getElementById('upsell-step-0');
    const s1 = document.getElementById('upsell-step-1');
    const s2 = document.getElementById('upsell-step-2');
    if (s0) s0.style.display = step === 0 ? 'grid' : 'none';
    if (s1) s1.style.display = step === 1 ? 'grid' : 'none';
    if (s2) s2.style.display = step === 2 ? 'grid' : 'none';

    root.style.display = 'block';
    dbgLift();

    // Scroll lock – gem top-position på body
    const scrollY = window.scrollY;
    document.body.style.overflow   = 'hidden';
    document.body.style.position   = 'fixed';
    document.body.style.top        = `-${scrollY}px`;
    document.body.style.left       = '0';
    document.body.style.right      = '0';
  }

  function closePopup(root) {
    root.style.display = 'none';

    // Læs top-værdien NÅR vi lukker (mest pålidelig metode)
    const bodyTop = document.body.style.top;
    const scrollY = Math.abs(parseInt(bodyTop || '0'));

    document.body.style.overflow   = '';
    document.body.style.position   = '';
    document.body.style.top        = '';
    document.body.style.left       = '';
    document.body.style.right      = '';

    window.scrollTo(0, scrollY);
  }

  // Nødudgang: release scroll ved navigation/tab-skift
  window.addEventListener('pagehide', () => {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
    }
  });

  /* -------------------------------------------------------
     Opdater cart tæller
  ------------------------------------------------------- */
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('.cart-count-bubble span, #cart-icon-bubble .badge').forEach(el => {
        el.textContent = cart.item_count || 0;
      });
      if (window.PUB_SUB_EVENTS?.cartUpdate && window.publish) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-popup' });
      }
    } catch {}
  }

  function showFormError(msg, productForm) {
    const wrap = document.querySelector('product-form')?.querySelector('.product-form__error-message-wrapper');
    const el = wrap?.querySelector('.product-form__error-message');
    if (wrap && el) {
      el.textContent = msg; wrap.removeAttribute('hidden');
      setTimeout(() => wrap.setAttribute('hidden', ''), 6000);
    } else { alert(msg); }
  }

  function formatDKK(cents) {
    return (cents / 100).toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' kr';
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function setText(selector, text) {
    const el = document.querySelector(selector);
    if (el && text) el.textContent = text;
  }

  /* -------------------------------------------------------
     Start. Skal staa NEDERST: init laeser DEBUG og de andre
     var-erklaeringer, og de er foerst tildelt paa dette punkt.
  ------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
